"use client";

import React, { useEffect, useRef, useState } from "react";
import { ArrowRight, Leaf, MapPin, ShieldCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const missionValues = [{
  id: "sustainability",
  title: "Licensed & Fully Insured",
  description: "Our operations are backed by full licencing and comprehensive insurance, ensuring total peace of mind for our commercial partners. We maintain strict adherence to all health, safety, and industry regulations to protect your investment and our workforce.",
  icon: ShieldCheck,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1641543/img/warehouse_licensed.png"
}, {
  id: "artisans",
  title: "Commercial Interior Fitouts",
  description: "Specialising in transformative commercial environments, we deliver turnkey solutions from conceptual blueprinting to final execution. Our team handles complex infrastructure requirements for offices, retail spaces, and industrial facilities.",
  icon: MapPin,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1641543/img/commercial_fitout.png"
}, {
  id: "quality",
  title: "Technical Engineering Precision",
  description: "Every detail is executed with engineering-grade accuracy. We utilise advanced project management tools and construction methodologies to ensure structural integrity, functional excellence, and aesthetic perfection in every square foot.",
  icon: Leaf,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1641543/img/technical_precision.png"
}];
export default function NotreMission() {
  const [activeIndex, setActiveIndex] = useState(0);
  const sectionRefs = useRef<(HTMLDivElement | null)[]>([]);
  useEffect(() => {
    const handleScroll = () => {
      const viewportCenter = window.innerHeight / 2;
      let closestIndex = 0;
      let minDistance = Infinity;
      sectionRefs.current.forEach((ref, index) => {
        if (ref) {
          const rect = ref.getBoundingClientRect();
          const elementCenter = rect.top + rect.height / 2;
          const distance = Math.abs(viewportCenter - elementCenter);
          if (distance < minDistance) {
            minDistance = distance;
            closestIndex = index;
          }
        }
      });
      if (closestIndex !== activeIndex) {
        setActiveIndex(closestIndex);
      }
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, [activeIndex]);
  return null;
}